/* eslint-disable spire/fenced-imports */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

const enum fields {
    height = "height",
    width = "width",
    source = "source",
}

interface OwnProps extends WidgetProps {
    fields: {
        height: number;
        width: number;
        source: string;
    };
}

export interface GoogleMapStyles {
    mainContainer?: InjectableCss;
}

export const style: GoogleMapStyles = {
    mainContainer: {
        css: css`
            max-width: 100%;
            iframe {
                max-width: 100%;
            }
        `,
    },
};

const GoogleMapStyles: React.FC<OwnProps> = ({ fields }) => {
    return (
        <>
            <StyledWrapper {...style.mainContainer}>
                <iframe
                    src={fields.source}
                    width={`100%`}
                    height={`${fields.height}px`}
                    allowFullScreen={true}
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: GoogleMapStyles,
    definition: {
        group: "Contact Us",
        displayName: "customMap",
        fieldDefinitions: [
            {
                name: fields.height,
                editorTemplate: "IntegerField",
                fieldType: "Translatable",
                displayName: "Height",
                defaultValue: 342,
            },
            {
                fieldType: "General",
                name: fields.source,
                editorTemplate: "MultilineTextField",
                displayName: "URL",
                defaultValue:
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.0432499983463!2d-90.2748478848533!3d38.62488607961363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d8b510eb253d1f%3A0xb4deac509cda19af!2s5121%20Manchester%20Ave%2C%20St.%20Louis%2C%20MO%2063110%2C%20USA!5e0!3m2!1sen!2sin!4v1663313876856!5m2!1sen!2sin",
            },
        ],
    },
};

export default widgetModule;
